export function extractNumbers(value?: string) {
  if (value == null) {
    return value;
  }

  return value.replace(/\D/g, '');
}
